import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FaCopy, FaLink} from "react-icons/fa";
import TreemapChartPreview, {PiechartPreview, TreemapchartPreview} from "./render";

export const Treemapchart = () => {
    const [copied, setCopied] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [environment, setEnvironment] = useState(queryParams.get("environment") || "DEV");
    const [height, setHeight] = useState(queryParams.get("height") || 500);
    const [series, setSeries] = useState(queryParams.get("series") || "Room 1,Room 2,Room 3");
    const [sizes, setSizes] = useState(queryParams.get("sizes")|| "500,200,350");
    const [values, setValues] = useState(queryParams.get("values") || "1,25,75");
    const [colorPrimary, setColorPrimary] = useState(queryParams.get("colorPrimary") || "#00bfff");
    const [colorSecondary, setColorSecondary] = useState(queryParams.get("colorSecondary") || "#0000ff");
    const [colorBackground, setColorBackground] = useState(queryParams.get("colorBackground") || "#FFFFFF");



    const handleCopy = () => {
        navigator.clipboard.writeText(linkToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const linkToCopy =
        process.env.REACT_APP_FRONT_URL + "/treemapChart?na=1"
        + "&environment=PROD"
        + "&height=" + height
        + "&colorBackground=" + colorBackground
        + "&series=" + series
        + "&sizes=" + sizes
        + "&values=" + values
        + "&colorPrimary=" + colorPrimary
        + "&colorSecondary=" + colorSecondary
    ;





    return (
        <div className="flex flex-col items-center justify-center" style={{width:'100%',backgroundColor:colorBackground}}>
            {environment=== "DEV" && (
                <>
                    <h1 style={{fontSize: 40, fontWeight: 'bold'}}>
                        Treemap Chart  Component
                    </h1>
                    <br/><br/>
                    <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
                    <br/>

                    <h3 className="text-md font-semibold mb-3 mt-10">Chart configuration</h3>
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">series</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    categorias de series, separadas por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSeries(e.target.value)}
                                        value={series}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">sizes</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Tamaño de las series, separadas por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSizes(e.target.value)}
                                        value={sizes}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">values</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    valores de las series, separadas por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setValues(e.target.value)}
                                        value={values}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">colorPrimary</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color inicial del gradient
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setColorPrimary(e.target.value)}
                                        value={colorPrimary}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">colorSecondary</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color final del gradient
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setColorSecondary(e.target.value)}
                                        value={colorSecondary}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">height</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Height del grafico
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setHeight(e.target.value)}
                                        value={height}
                                    />
                                </p>
                            </div>
                        </div>


                    </div>
                    <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>

                    <br/><br/>
                </>)}

            <TreemapChartPreview
                environment={environment}
                seriesString={series}
                sizeString={sizes}
                occupations={
                    (() => {
                        const valuesArray = values.split(",").map(Number);
                        const sizesArray = sizes.split(",").map(Number);

                        if (valuesArray.length === sizesArray.length) {
                            return valuesArray.map((value, index) =>
                                sizesArray[index] !== 0 ? value / sizesArray[index] : 0 // Manejar divisiones por cero
                            );
                        } else {
                            console.error("Lengths of values and sizes do not match.");
                            return [];
                        }
                    })()
                }
                height={height}
                colorRange={[colorPrimary, colorSecondary]}
            />


            {environment === "DEV" && (
                <div>
                    <br/><br/>
                    <div className="flex items-center mb-5">
                        <button
                            onClick={handleCopy}
                            className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
                        >
                            <FaCopy className="mr-2"/>
                            {copied ? "Copied!" : "Copy Link"}
                        </button>

                        <Link to={"/"}>
                            <button
                                className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600" >
                                <FaLink className="mr-2"/>
                                Go to Home
                            </button>
                        </Link>
                    </div>

                </div>
            )}
        </div>

    );
};
